import(/* webpackMode: "eager", webpackExports: ["default"] */ "G:\\Nexo3d.ir\\node_modules\\lucide-react\\dist\\esm\\Icon.mjs");
;
import(/* webpackMode: "eager" */ "G:\\Nexo3d.ir\\node_modules\\next\\dist\\client\\app-dir\\link.js");
;
import(/* webpackMode: "eager", webpackExports: ["Image"] */ "G:\\Nexo3d.ir\\node_modules\\next\\dist\\client\\image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["ProductMarquee"] */ "G:\\Nexo3d.ir\\src\\components\\product-carousel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ProductDetail"] */ "G:\\Nexo3d.ir\\src\\components\\product-detail.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["QuickAdd"] */ "G:\\Nexo3d.ir\\src\\components\\quick-add.tsx");
